module.exports = __webpack_public_path__ + "static/fonts/element-icons.2fad952a.woff";